import React, { useState, useEffect } from "react";
import "./styles/Experience.css";

import { ReactComponent as WorkIcon } from "../assets/work.svg";
import { ReactComponent as SchoolIcon } from "../assets/school.svg";
import { ReactComponent as PersonalIcon } from "../assets/personal.svg";

import timelineData from "./data/timelineData";

import {
  VerticalTimeline,
  VerticalTimelineElement,
} from "react-vertical-timeline-component";

import "react-vertical-timeline-component/style.min.css";

const Experience = () => {
  const workIconStyles = { background: "cyan" };
  const schoolIconStyles = { background: "pink" };
  const personalIconStyles = { background: "coral" };

  const [componentHeight, setComponentHeight] = useState(0);

  useEffect(() => {
    const component1 = document.querySelector("#nav-app-bar");
    if (component1) {
      setComponentHeight(component1.offsetHeight);
    }
  }, []);

  const [descriptionVisibility, setDescriptionVisibility] = useState(
    timelineData.map(() => false)
  );

  // Function to toggle description visibility for a specific element
  const toggleDescription = (index) => {
    setDescriptionVisibility((prevVisibility) => {
      const newVisibility = [...prevVisibility];
      newVisibility[index] = !newVisibility[index];
      return newVisibility;
    });
  };

  const toggleAll = (value) => {
    setDescriptionVisibility(timelineData.map(() => value));
  };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 700) {
        setDescriptionVisibility(timelineData.map(() => false)); 
      } else {
        setDescriptionVisibility(timelineData.map(() => true));
      }
    };

    // Add event listener for window resize
    window.addEventListener("resize", handleResize);

    // Remove event listener when component unmounts
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <div id="experience" className="section" style={{ marginTop: `calc(${componentHeight + 50}px)` }}>
      <h1 className="section-header">Experience Timeline</h1>
      <div id="timeline-description-toggles">
        <button onClick={() => toggleAll(true)}>Extend All</button>
        <button onClick={() => toggleAll(false)}>Collapse All</button>
      </div>
      <VerticalTimeline>
        {timelineData.map((element, index) => {
          const { icon, link, name, title, location, date, description, brief } = element;
          const hasNoLink = link === "none";

          let iconStyle, iconComponent;
          switch (icon) {
            case "work":
              iconStyle = workIconStyles;
              iconComponent = <WorkIcon />;
              break;
            case "school":
              iconStyle = schoolIconStyles;
              iconComponent = <SchoolIcon />;
              break;
            case "personal":
              iconStyle = personalIconStyles;
              iconComponent = <PersonalIcon />;
              break;
            default:
              iconStyle = {};
              iconComponent = null;
          }

          return (
            <VerticalTimelineElement
              key={element.id}
              date={date}
              dateClassName="timeline-date"
              iconStyle={iconStyle}
              icon={iconComponent}
              position={icon !== "school" ? "left" : "right"}
            >
              <h3
                className={`vertical-timeline-element-title title ${hasNoLink ? "" : "linked"}`}
                onClick={() => { if (!hasNoLink) window.open(link, "_blank"); }}
              >
                {name}
              </h3>
              <h3 className="vertical-timeline-element-title etitle">
                ({title})
              </h3>
              <h5 className="vertical-timeline-element-subtitle">{location}</h5>

              <div className={`timeline-description ${descriptionVisibility[index] ? "long" : "short"}`}>
                {descriptionVisibility[index] ? (
                  <ul>
                    {description.map((item, i) => (<li key={i}>{item}</li>))}
                  </ul>
                ) : (
                  <p>{brief}</p>
                )}
              </div>

              <button
                className="timeline-description-button"
                onClick={() => toggleDescription(index)}
              >
                {descriptionVisibility[index]
                  ? "> Hide Full Description <"
                  : "< Show Full Description >"}
              </button>
            </VerticalTimelineElement>
          );
        })}
      </VerticalTimeline>
    </div>
  );
};

export default Experience;